import { CareerId } from '@common/const/catalog/career';
import { SxProps } from '@cp/ds/src/theme';
import { careerIdToLayoutData } from '../lib';

export const CareerIcon = ({ careerId, ...props }: { careerId?: CareerId; sx?: SxProps }) => {
  const Icon = careerId ? careerIdToLayoutData[careerId].iconComponent : () => null;
  return <Icon {...props} />;
};
